import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { LanguageAbbreviation } from '@/constants/common';
import translation_de from './de';
import translation_en from './en';
import translation_es from './es';
import translation_id from './id';
import translation_ja from './ja';
import translation_pt_br from './pt-br';
import { createTranslationTable, flattenObject } from './until';
import translation_vi from './vi';
import translation_zh from './zh';
import translation_zh_traditional from './zh-traditional';

const resources = {
  [LanguageAbbreviation.En]: translation_en,
  [LanguageAbbreviation.Zh]: translation_zh,
  [LanguageAbbreviation.ZhTraditional]: translation_zh_traditional,
  [LanguageAbbreviation.Id]: translation_id,
  [LanguageAbbreviation.Ja]: translation_ja,
  [LanguageAbbreviation.Es]: translation_es,
  [LanguageAbbreviation.Vi]: translation_vi,
  [LanguageAbbreviation.PtBr]: translation_pt_br,
  [LanguageAbbreviation.De]: translation_de,
};
const enFlattened = flattenObject(translation_en);
const viFlattened = flattenObject(translation_vi);
const esFlattened = flattenObject(translation_es);
const zhFlattened = flattenObject(translation_zh);
const jaFlattened = flattenObject(translation_ja);
const pt_brFlattened = flattenObject(translation_pt_br);
const zh_traditionalFlattened = flattenObject(translation_zh_traditional);
const deFlattened = flattenObject(translation_de);
export const translationTable = createTranslationTable(
  [
    enFlattened,
    viFlattened,
    esFlattened,
    zhFlattened,
    zh_traditionalFlattened,
    jaFlattened,
    pt_brFlattened,
    deFlattened,
  ],
  [
    'English',
    'Vietnamese',
    'Spanish',
    'zh',
    'zh-TRADITIONAL',
    'ja',
    'pt-BR',
    'Deutsch',
  ],
);

// 从环境变量获取默认语言，如果没有设置或值无效，则使用 'en'
const getDefaultLanguage = (): string => {
  // 优先从 window 对象读取（通过 script 标签注入）
  const windowLang = (window as any).__SYSTEM_DEFAULT_LANGUAGE__;
  if (windowLang && Object.values(LanguageAbbreviation).includes(windowLang as LanguageAbbreviation)) {
    return windowLang;
  }
  // 兼容旧的方式（构建时注入）
  const envLang = process.env.SYSTEM_DEFAULT_LANGUAGE;
  if (envLang && Object.values(LanguageAbbreviation).includes(envLang as LanguageAbbreviation)) {
    return envLang;
  }
  return 'en';
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      // 只使用 localStorage，禁用浏览器语言检测
      order: ['localStorage'],
      lookupLocalStorage: 'lng',
      // 禁用浏览器语言检测，避免不同浏览器显示不同语言
      caches: ['localStorage'],
    },
    supportedLngs: Object.values(LanguageAbbreviation),
    resources,
    fallbackLng: getDefaultLanguage(),
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
